import api from '../api';

export const getCobitDomains = () => api.get('maturity/cobit/domains/');
export const loadCobitDomain = (domainId) => api.get(`maturity/cobit/domain/${domainId}/load/`);

export const saveCobitDomain = (domainId, payload) =>
  api.post(`maturity/cobit/domain/${domainId}/save/`, payload);

export const submitCobitDomain = (domainId, payload) =>
  api.post(`maturity/cobit/domain/${domainId}/submit/`, payload);

export const uploadCobitEvidence = (formData) =>
  api.post('maturity/upload-evidence-file/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const removeCobitEvidence = (responseId, fileId) =>
  api.delete(`maturity/evidence-files/${responseId}/cobit/${fileId}/remove/`);